import React from 'react';
import styled from 'styled-components';
import { Card, CardTitle, CardActions } from 'material-ui/Card';
import firebase from 'firebase/app';
import RaisedButton from 'material-ui/RaisedButton';
import { theme } from '../../utils/getTheme';
import doodle from '../../images/doodle.png';
import { auth } from '../../utils/configureFirebase';

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${props => props.theme.backgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    width: 640px;
  }
`;

const Doodle = styled.img`
  position: fixed;
  bottom: 0;
  right: 0;
  max-height: 70%;
`;

const Login = () => (
  <Wrapper>
    <Doodle src={doodle} alt="MyAnatomy" />
    <Card>
      <CardTitle
        title="Login to MyAnatomy"
        subtitle="Drive Admin Panel"
      />
      <CardActions>
        <RaisedButton
          label="Login With Google"
          backgroundColor="#d34836"
          labelColor={theme.alternateTextColor}
          onTouchTap={() => {
            const provider = new firebase.auth.GoogleAuthProvider();
            auth.signInWithPopup(provider).then((response)=> {
              localStorage.setItem('appToken',response.user._lat)
            }).catch((err) => {
              console.error(err.message)
            });
          }}
        />
      </CardActions>
    </Card>
  </Wrapper>
);

export default Login;



// WEBPACK FOOTER //
// ./src/views/Login/Login.js